import { ErrorHandler, Injectable, NgModule } from '@angular/core';
import { BrowserModule, ɵDomSharedStylesHost } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/es-US';
import localePT from '@angular/common/locales/pt';
import localeES from '@angular/common/locales/es';

import { SharedModule } from './shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { AccountMigrationModule } from './account-migration/account-migration.module';
import { TranslocoService } from '@ngneat/transloco';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import {
  CSP_NONCE_INJECTION_TOKEN,
  CustomDomSharedStylesHost,
} from './custom-dom-shared-styles-host.service';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { MatChipsModule } from '@angular/material/chips';

registerLocaleData(localeEN);
registerLocaleData(localeES);
registerLocaleData(localePT);

/**
 * Handles errors that bubble all the way up
 */
@Injectable({ providedIn: 'root' })
class UnexpectedErrorHandler implements ErrorHandler {
  unexpectedError = 'unexpected-error';

  /**
   * @constructor
   * @param {TranslocoService} transloco
   */
  constructor(transloco: TranslocoService) {
    transloco.selectTranslate(this.unexpectedError).subscribe((translation) => {
      this.unexpectedError = translation;
    });
  }

  /**
   * Pops up a snack bar informing of an unexpected error
   * @param {any} error
   */
  handleError(error: any) {
    if (environment.consoleLogErrors) {
      // eslint-disable-next-line
      console.error(error);
    }
  }
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    TranslocoRootModule,
    SharedModule,
    PagesModule,
    MatChipsModule,
    NbEvaIconsModule,
    AccountMigrationModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    { provide: ErrorHandler, useClass: UnexpectedErrorHandler },
    { provide: ɵDomSharedStylesHost, useClass: CustomDomSharedStylesHost },
    {
      provide: CSP_NONCE_INJECTION_TOKEN,
      useFactory: () =>
        document
          .querySelector('meta[name="csp-nonce"]')
          ?.getAttribute('content'),
    },
  ],
  bootstrap: [AppComponent],
})
/**
   TODO: JSDoc
 **/
export class AppModule {}
